/* Light palette for the redesigned sidebar. ThemeStyle injects this with the
   built-in light theme unless a custom theme or CSS override styles the classic
   sidebar tokens. The sidebarRedesign* values can be overridden one at a time
   from a custom theme or the CSS override, since those are declared later. */
:root {
  --color-sidebarRedesignBackground: var(--palette-white);
  --color-sidebarRedesignItemText: var(--palette-navy800);
  --color-sidebarRedesignItemBackgroundHover: var(--palette-navy100);
  --color-sidebarRedesignItemAccentSelected: var(--palette-purple500);
  --color-sidebarRedesignItemTextSelected: var(--palette-purple600);
  --color-sidebarRedesignItemBackgroundSelected: var(--palette-purple100);
  --color-sidebarRedesignItemBackgroundFailed: var(--palette-red500);
  --color-sidebarRedesignHeaderText: var(--palette-gray700);
  --color-sidebarRedesignTextSubdued: var(--palette-navy600);
  --color-sidebarRedesignTextMuted: var(--palette-navy400);
  --color-sidebarRedesignRightBorder: var(--palette-border);
}

/* Derived tokens are redeclared because var() references in custom
   properties resolve where the property is declared. */
.sidebar-redesign {
  border-right: 2px solid var(--color-sidebarRedesignRightBorder);
  --color-sidebarBackground: var(--color-sidebarRedesignBackground);
  --color-sidebarItemText: var(--color-sidebarRedesignItemText);
  --color-sidebarItemBackgroundHover: var(
    --color-sidebarRedesignItemBackgroundHover
  );
  --color-sidebarItemAccentSelected: var(
    --color-sidebarRedesignItemAccentSelected
  );
  --color-sidebarItemTextSelected: var(--color-sidebarRedesignItemTextSelected);
  --color-sidebarItemBackgroundSelected: var(
    --color-sidebarRedesignItemBackgroundSelected
  );
  --color-sidebarItemBackgroundFailed: var(
    --color-sidebarRedesignItemBackgroundFailed
  );
  --color-sidebarHeaderText: var(--color-sidebarRedesignHeaderText);
  --color-sidebarTextSubdued: var(--color-sidebarRedesignTextSubdued);
  --color-sidebarTextMuted: var(--color-sidebarRedesignTextMuted);
  --color-sidebarItemTextUpdated: var(--color-sidebarItemText);
  --color-sidebarTextFailed: var(--color-sidebarItemBackgroundFailed);
  --color-sidebarBackgroundFailedSubtle: color-mix(
    in srgb,
    var(--color-sidebarItemBackgroundFailed) 16%,
    transparent
  );
  --color-sidebarBorder: var(--color-sidebarItemBackgroundHover);
  --color-sidebarControlBackground: var(--color-sidebarItemBackgroundHover);
  --color-sidebarBrand: var(--color-sidebarItemAccentSelected);
}
